import { useSelector } from 'react-redux'
import { eligibleDependentEntriesSelector } from 'apps/formsCreationKit/store/selectors/entities'
import { blackListedTypesForMirror } from 'apps/builder/lib/utils'
import {
  LabelInput,
  EntryTypeSelect,
  StandardDesignConfig,
  HideOnPdfToggle,
} from 'apps/studio/components/settings/fields/Base/standard'

import { SettingsLabel } from 'apps/studio/components/shared/inputs/SettingsLabel'

const MirrorFieldSelect = {
  label: 'Mirror Field',
  settingType: 'sheetEntrySelect',
  updateType: 'entry',
  property: 'summary_entry',
  nestedProp: 'guid',
  tooltip: 'Choose the field you want to mirror.',
  dynamicChoices: () => {
    return useSelector(eligibleDependentEntriesSelector).reduce(
      (screens, { sheet, entries, screenLabel }) => {
        const validEntries = entries.reduce((acc, entry) => {
          const { type, label, placeholder, guid } = entry
          if (!blackListedTypesForMirror.includes(type)) {
            acc.push({
              value: guid,
              label: label ? label : placeholder,
              type,
              sheet,
            })
          }
          return acc
        }, [])

        if (validEntries.length) {
          screens.push({
            label: screenLabel,
            options: validEntries,
          })
        }
        return screens
      },
      []
    )
  },
}

export const MirrorStandardSettings = [
  LabelInput,
  EntryTypeSelect,
  SettingsLabel('Config'),
  MirrorFieldSelect,
  ...StandardDesignConfig,
  HideOnPdfToggle,
]
